import React, { Component } from "react";
import { Table, Pagination, Col, Row, Button, Select, Input } from "antd";
import moment from "moment";
import { strings } from "../../../helpers";

const { Option } = Select;
const { Search } = Input;
const searchOptions = {
  componentRestrictions: { country: "in" }
};

export default class MetricsView extends Component {
  render() {
    const { details } = this.props;

    const columns = [
      {
        title: "Total Visits",
        key: "total_patient_visits",
        dataIndex: "total_patient_visits",
        align: "left",
        render: record => <div>{record}</div>
      },
      {
        title: "Total Bills",
        dataIndex: "total_bills",
        key: "total_bills",
        align: "left"
      },
      {
        title: "Total Care Plans",
        dataIndex: "total_careplans",
        key: "total_careplans",
        align: "left"
      },
      {
        title: "Total Labs Referrals",
        dataIndex: "total_lab_referrals",
        key: "total_lab_referrals",
        align: "left"
      },
      {
        title: "Total Pharmacy Referrals",
        dataIndex: "total_pharmacy_referrals",
        key: "state",
        align: "left"
      },
      {
        title: "Total Doctor Referrals",
        dataIndex: "total_doctor_referrals",
        key: "state",
        align: "left"
      },
      {
        title: "Latest Patient Visit",
        dataIndex: "latest_patient_visit",
        key: "state",
        align: "left",
        render: record => (
          <div>
            {record ? (
              <div>{moment(record).format("DD-MM-YYYY")}</div>
            ) : (
              <div>-</div>
            )}
          </div>
        )
      }
    ];

    let source = [];
    if (details && details.metrics) {
      source = [details.metrics];
    }

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              Metrics
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              //onRowClick={record => navigateToClinicDetails(record.id)}
              columns={columns}
              dataSource={source}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
      </div>
    );
  }
}
